import React from 'react';

// ─── Info panel shown on the right when a circle (node-type) step is selected ──
// Rendered as a positioned div overlay inside .fc-wrapper, not inside the SVG.
export default function CircleInfoPanel({ step, onClose }) {
  if (!step || !step.stepDescription) return null;

  return (
    <div className="fc-circle-info-panel" role="complementary" aria-label="Step information">
      <button className="fc-circle-info-close" onClick={onClose} aria-label="Close">×</button>
      <div className="fc-circle-info-icon">ℹ</div>
      <h3 className="fc-circle-info-title">{step.stepTitle}</h3>
      <p className="fc-circle-info-body">{step.stepDescription}</p>
    </div>
  );
}
